import { LegalClientLegalHeadFirstHeadForLegalClientLegalHeadEntity } from 'api/types/entity';

export const checkFirstHeadFullness = (
  b: LegalClientLegalHeadFirstHeadForLegalClientLegalHeadEntity
) => !!b.onboarding?.isCompletedByRepresentative;
